import { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { AlertCircle, Loader2 } from 'lucide-react'
import { eformService } from './eform.service'

export default function UrlRedirectPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const code = searchParams.get('t') ?? ''
  const [error, setError] = useState('')

  useEffect(() => {
    if (!code) {
      setError('Invalid link. No short code provided.')
      return
    }

    eformService
      .resolveShortUrl(code)
      .then((result) => {
        switch (result.type) {
          case 'eform':
            if (result.token) {
              navigate(`/eform?t=${encodeURIComponent(result.token)}`, { replace: true })
            } else {
              window.location.href = result.fullUrl
            }
            break
          case 'payment':
          case 'document':
          case 'other':
          default:
            window.location.href = result.fullUrl
            break
        }
      })
      .catch((err: Error & { code?: string }) => {
        setError(err.message || 'This link has expired or is no longer valid.')
      })
  }, [code, navigate])

  if (error) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <div className="max-w-sm w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center">
          <AlertCircle className="h-12 w-12 text-amber-400 mx-auto mb-4" />
          <h2 className="text-lg font-semibold text-slate-800 mb-2">Link Unavailable</h2>
          <p className="text-sm text-slate-500">{error}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 text-primary animate-spin mx-auto" />
        <p className="text-sm text-slate-500 mt-3">Redirecting...</p>
      </div>
    </div>
  )
}
